import { Component, OnInit, Input } from '@angular/core';
import { map, takeWhile } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { OptionAddEditModalComponent } from '../option-add-edit-modal/option-add-edit-modal.component';
import { Option } from 'src/app/models/option';
import {OptionGroupService} from "../../services/option-group.service";

interface OptionCheckbox {
  option: Option,
  isMain: boolean,
  isExtra: boolean
}

@Component({
  selector: 'app-option-select-modal',
  templateUrl: './option-select-modal.component.html',
  styleUrls: ['./option-select-modal.component.scss'],
})
export class OptionSelectModalComponent implements OnInit {

  @Input() itemOptions: Option[];
  optionCheckboxes: OptionCheckbox[] = [];

  private isComponentActive = true;

  constructor(
    private modalController: ModalController,
    private optionService: OptionGroupService,
  ) { }

  ngOnInit() {
    this.itemOptionToOptionCheckbox();
    this.observeRestaurantOptions();

    this.modalController.getTop()
    .then((ionModal: HTMLIonModalElement) => ionModal.cssClass = 'option-select-modal');
  }

  observeRestaurantOptions() {

    this.optionService.observeOptionGroups()
    .pipe(
        takeWhile(() => this.isComponentActive),
        map(options => options.sort((a, b) => {
            if ( a.name > b.name ) return  1;
            if ( a.name < b.name ) return -1;
            return 0;
        }))
    )
    .subscribe((options) => {
      const optionCheckboxesBeforeUpdate = [...this.optionCheckboxes];
      this.optionCheckboxes = [];

      options.forEach((option) => {
        const prevOption = optionCheckboxesBeforeUpdate.find((value) => value.option['uid'] === option.uid);
        const  isMain = prevOption ? prevOption.isMain  : false;
        const isExtra = prevOption ? prevOption.isExtra : false;

        // this.optionCheckboxes.push({option: option, isMain, isExtra});
      });
    });
  }

  dismissSelfWithData() {
    this.optionCheckboxToItemOption();
    this.modalController.dismiss({itemOptions: this.itemOptions});
  }

  dismissSelfWithoutData() {
    this.modalController.dismiss();
  }

  async addOption() {
    const modal = await this.modalController.create({
      component: OptionAddEditModalComponent,
      backdropDismiss: false,
    });

    modal.onDidDismiss().then(async ({ data }) => {
      if (!data || !data.option) return
      // this.optionService.addOptionGroup(data.option);
    });

    await modal.present();
  }

  private itemOptionToOptionCheckbox() {
    this.itemOptions.forEach((option) => {
      // this.optionCheckboxes.push({
      //   option: new Option(option.optionId, '', '', 0),
      //   isMain: option.isMain,
      //   isExtra: option.isExtra
      // });
    });
  }

  private optionCheckboxToItemOption() {
    this.itemOptions = [];
    this.optionCheckboxes.forEach((checkbox) => {
      if (!checkbox.isMain && !checkbox.isExtra) return;
      // this.itemOptions.push(new ItemOption(checkbox.option.uid, checkbox.isMain, checkbox.isExtra));
    });
  }

  ngOnDestroy() {
    this.isComponentActive = false;
  }

}
